"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const afterpaycard = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-afterpaycard` : '') + (description ? ` desc-afterpaycard` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-afterpaycard"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-afterpaycard"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.5294 0H5.47059C3.00155 0 1 1.79086 1 4V20C1 22.2091 3.00155 24 5.47059 24H34.5294C36.9985 24 39 22.2091 39 20V4C39 1.79086 36.9985 0 34.5294 0Z",
    fill: "#00D64F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.8071 10.5742C23.3356 11.1161 24.4915 12.1636 24.4915 13.9336C24.4915 16.1525 22.6847 17.7904 19.8642 17.9637L19.589 19.2762C19.5621 19.4045 19.4489 19.4964 19.3179 19.4964H17.1479C16.9691 19.4964 16.8371 19.3294 16.8784 19.1554L17.2267 17.6877C15.8286 17.2899 14.7036 16.5161 14.0477 15.5609C13.9652 15.4407 13.9926 15.2764 14.1077 15.1868L15.6244 14.0072C15.7494 13.91 15.9286 13.9385 16.021 14.0671C16.8246 15.1856 18.0575 15.8481 19.5428 15.8481C20.8793 15.8481 21.8907 15.1979 21.8907 14.2587C21.8907 13.5362 21.385 13.2111 19.6873 12.8499C16.7614 12.2358 15.6055 11.1522 15.6055 9.38219C15.6055 7.32855 17.3314 5.77721 19.9349 5.57572L20.2191 4.22015C20.246 4.09187 20.3591 4 20.4902 4H22.631C22.8076 4 22.9391 4.16305 22.9017 4.33565L22.5726 5.85451C23.6929 6.19935 24.6051 6.81594 25.1729 7.5768C25.2609 7.69474 25.2383 7.86174 25.1245 7.95505L23.7408 9.08972C23.6205 9.18832 23.445 9.16679 23.3472 9.04587C22.6439 8.17604 21.5368 7.68446 20.3375 7.68446C19.001 7.68446 18.1702 8.26241 18.1702 9.09322C18.1702 9.77954 18.8204 10.1408 20.8071 10.5742Z",
    fill: "white"
  }));
};
var _default = exports.default = afterpaycard;